import { ApplicationStage } from '../types/ApplicationsStage';
import { Option } from 'common/types';

export const stageOptions: Option[] = [
  {
    value: ApplicationStage.PHONE_SCREEN,
    label: 'Phone screen'
  },
  {
    value: ApplicationStage.SUBMITTED,
    label: 'Submitted'
  },
  {
    value: ApplicationStage.INTERVIEW,
    label: 'Interview'
  },
  {
    value: ApplicationStage.OFFER_EXTENDED,
    label: 'Offer extended'
  },
  {
    value: ApplicationStage.OFFER_ACCEPTED,
    label: 'Offer accepted'
  },
  {
    value: ApplicationStage.HIRED,
    label: 'Hired'
  },
  {
    value: ApplicationStage.REJECTED,
    label: 'Rejected'
  },
  {
    value: ApplicationStage.NO_STAGE,
    label: 'No stage'
  }
];
